import { combineReducers } from 'redux'

import products from './products'

export default combineReducers({
  products
})
